import React, { useState } from 'react';

export default function ReplaceModal({ item, onConfirm, onClose }) {
  const [value, setValue] = useState(item.current_name);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    onConfirm(value.trim());
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h3 className="modal-title">Reemplazar equipo</h3>

        <div style={{ marginBottom: 16 }}>
          <div className="form-label" style={{ marginBottom: 6 }}>Equipo original</div>
          <div style={{
            padding: '8px 12px',
            background: 'var(--surface2)',
            borderRadius: 'var(--radius-sm)',
            fontSize: 14,
            color: 'var(--text-dim)',
            fontFamily: 'DM Mono, monospace'
          }}>
            {item.original_name}
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Reemplazar por</label>
            <input
              autoFocus
              className="input"
              value={value}
              onChange={e => setValue(e.target.value)}
              placeholder="Nombre del equipo de reemplazo"
            />
          </div>

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancelar</button>
            {item.is_replaced && (
              <button
                type="button"
                className="btn btn-ghost"
                onClick={() => onConfirm(item.original_name)}
              >
                Restaurar original
              </button>
            )}
            <button type="submit" className="btn btn-primary" disabled={!value.trim()}>
              Confirmar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
